/*
 * Copyright 2024 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-wallet/blob/master/LICENSE.md
 */
package org.mifospay.core.network.services

import io.github.jan.supabase.postgrest.Postgrest
import org.mifospay.core.model.instance.InstancesConfig

/**
 * Service for interacting with app_config table in Supabase.
 */
class AppConfigService(
    private val postgrest: Postgrest,
) {
    suspend fun fetchInstancesConfig(): InstancesConfig {
        return postgrest
            .from(TABLE_APP_CONFIG)
            .select()
            .decodeSingle<InstancesConfig>()
    }

    companion object {
        private const val TABLE_APP_CONFIG = "app_config"
    }
}
